<template>
  <yo-widget>
    <div class="full" slot="content">
      <yogui2 class="full" @switch="(v) => { $emit('switch', v) }" :earthID="earthID" :ownerID="ownerID"></yogui2>
      <!-- <yogui2 class="full" @switch="(v) => { $emit('switch', v) }" :earthID="earthID" :ownerID="ownerID" :marker="marker" :userData="userData" :initCreateRoomTitle="roomTitle" :initRoomTitle="roomTitle" @initRoomTitle="(v) => { roomTitle = v }"></yogui2> -->
    </div>
  </yo-widget>
</template>

<script>
import * as LOAD from './loadExt.js'
export default {
  props: {
    earthID: {},
    ownerID: {} // ,
    // room: {},
    // marker: {},
    // userData: {}
  },
  data () {
    return {
      // ready: true,
      // roomTitle: this.room
    }
  },
  mounted () {
    // let lib = 'https://yoteach-cloud-widget-lib.netlify.com/yoteach.umd.min.js
    let math = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML'
    let pep = 'https://code.jquery.com/pep/0.4.3/pep.js'
    /* eslint-disable */
    new LOAD.ext([math, pep], () => {
    })
    /* eslint-enable */
    // this.roomTitle = this.room
  },
  components: {
    'yo-widget': require('../yo/widget.vue').default,
    'yogui2': require('../yoteach2-gui/ChatRoomListView.vue').default
  }
}
</script>

<style scoped>
.center-full{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.full{
  width: 100%;
  height: 100%;
}
.welcome-title{
  font-size: 50px;
}
</style>
